import React from 'react';

import PageHeading from 'components/PageHeading';
import { useTranslations } from 'utils/hooks/useTranslations';

const MarketInfoAddressSelectionHeader = () => {
  const t = useTranslations('pages.marketInformationInquiryPage.marketInfoAddressPage.heading');
  return <PageHeading heading={t('header')} subheading={t('subheader')} />;
};

export default MarketInfoAddressSelectionHeader;
